import React from 'react';
import Review from 'components/review'; // Assuming Review is in the components folder
import { SkinPass } from "../../components/SkinPass";
import { MiniTable } from "../../components/MiniTable";



function TestPage() {
  return (
    <div>
      <h1>Test Page</h1>
      <Review />
      <br/>
      <SkinPass />
      <br/>
      <br/>
      <MiniTable />
      <br/>
    </div>
    
  );
}

export default TestPage;